import dayjs from 'dayjs';
import type { LoanFiltersType } from '~/types/loans';

export const dateFormat = 'YYYY-MM-DD';
export const defaultFilters: LoanFiltersType = {
  fromDate: dayjs()
    .subtract(7, 'day')
    .format(dateFormat) /* to apply filter for last 7 days data */,
  toDate: dayjs().format(dateFormat) /* today */,
  phone: '',
  pan: '',
  status: [],
  partner: '',
  referrers: [] as string[],
  loanApplicationNumber: '',
  page: 1,
  limit: 10,
  sortByjourneyStatus: '',
  sortByLoanStartedAt: '',
  sortByLoanModifiedAt: '',
};

export const filtersKey = 'loanFilters';
export const referralLink =
  'https://www.smallcase.com/loan-against-mutual-funds?referrer=';

export const dashboardDefinitions = {
  Partners:
    'Collaborate with potential loan applicants by facilitating the application process and providing support throughout. They can use the dashboard to track the progress of applications, ensuring timely follow-ups.',
  Referrers:
    'Referrers are partners who share unique referral links with users. These links allow referrers to generate loan applications and track the progress of their referrals through the dashboard. They can track the status of loan applications generated from their link.',
  Trackers:
    'The dashboard is designed to provide real-time tracking of loan applications. It allows referrers and partners to monitor key stages of the loan journey, from registration to disbursement, ensuring transparency and reducing the need for follow-ups.',
};

export const gatewayLogo =
  'https://gateway.smallcase.com/assets/images/svg/gateway-logo.svg';

/** True when app is served from South Indian Bank LAS domain */
export const isSIBHost = (): boolean =>
  typeof window !== 'undefined' &&
  window.location.hostname === 'las.southindianbank.bank.in';

/** South Indian Bank – apply flow referrer ID used in /apply/:referrerId */
export const SIB_REFERRER_ID = 'sibweb';
